import Boolean from '@components/Form/Boolean';
import Checkboxfield from '@components/Form/CheckboxField';
import DateField from '@components/Form/Date';
import LabelField from '@components/Form/ExtraInfo';
import DynamicFieldSet from '@components/Form/ListSettings';
import MatrizField from '@components/Form/MatrizField';
import NumberField from '@components/Form/NumberField';
import RadioButton from '@components/Form/RadioButton';
import RadioNumberField from '@components/Form/RadioNumber';
import RangeDateField from '@components/Form/RangeDate';
import RemainderDaysField from '@components/Form/remainderDays';
import SelectedField from '@components/Form/Selected';
import TextFieldSettings from '@components/Form/TextFieldSettings';
import UploadPerButton from '@components/Form/UploadPerButton';
import { Button } from 'antd';
import { Formik } from 'formik';
import { Effect } from 'formik-effect';
import _ from 'lodash';
import React from 'react';

import { FieldType, FormSettingsType } from '.';
import I18n from '../../i18n';
import styled from '../../styled-components';
import Buttongroup from './Buttongroup';
import Dropdown from './Dropdown';
import ErrorDisplay from './ErrorDisplay';
import Label from './Label';
import Link from './Link';
import MaskField from './MaskField';
import MissingPropsPlaceholder from './MissingPropsPlaceholder';
import PasswordField from './PasswordField';
import TextField from './TextField';
import TextFieldArea from './TextFieldArea';
import Upload from './Upload';



type PropsType = {
  settings: FormSettingsType;
  data?: { name: string; value?: any }[];
  debug?: boolean;
  onAllowSubmitChange?: Function;
  onSubmit?: Function;
  onNewSubmit?: Function;
  onCancel?: Function;
  onNewCancel?: Function;
  onReset?: Function;
  innerComponent?: any;
  customRegisterLabel?: string;
};

class FormBuilder extends React.Component<PropsType> {
  static defaultProps: Partial<PropsType> = {
    settings: {},
  };

  submitForm?: Function;

  getInitialValues = ({ fields }: { fields?: FieldType[] }) => {
    const { settings, data } = this.props;
    const initialValues = {};
    const clonedFields = JSON.parse(JSON.stringify(fields));
    let initialValuesSubItems: any[] = [];

    if (data) {
      clonedFields.map((field: FieldType) => {

        if (field.name === 'photoData') {
          field.initialValue = _.get(_.find(data, item => item.name === 'photo'), 'value') || '';
        } else {
          field.initialValue = _.get(_.find(data, item => item.name === field.name), 'value') || '';
        }
        return field;
      });
    }

    clonedFields.map((field: FieldType) => {
      if (field.type === 'fieldset') {
        const itemsArr = field.items
          ? field.items.map((subField: any) => {
            if (subField.name) {
              initialValues[subField.name] = subField.initialValue || '';
            }
            return subField;
          })
          : [];
        initialValuesSubItems = [...initialValuesSubItems, ...itemsArr];
      }
      if (field.type === 'numberrange' && field.nameFrom && field.nameTo) {
        initialValues[field.nameFrom] = field.initialValueFrom || '';
        initialValues[field.nameTo] = field.initialValueTo || '';
      } else {
        if (field.name) {
          initialValues[field.name] = field.initialValue || '';
        }

        if (field.nameComp) {
          initialValues[field.nameComp] = field.initialValue || '';
        }
      }
      return field;
    });

    return initialValues;
  };

  renderComponentByType = (field: FieldType, props: any, withError: boolean) => {
    const { values, setFieldValue, setTouched, handleBlur, handleFocus, submitForm, maxLength } = props;
    const value = values && field.name && values[field.name] ? values[field.name] : '';

    this.submitForm = submitForm;
    const locale = localStorage.locale

    if (field.name) {

      switch (field.type) {
        case 'text':
        case 'email':
          return (
            <React.Fragment>
              <TextField
                type={field.type}
                className={field.className}
                name={field.name}
                disabled={field.disabled}
                label={field.label}
                placeholder={field.placeholder}
                addorn={field.addorn}
                value={value}
                withError={withError}
                setFieldValue={setFieldValue}
                setTouched={setTouched}
                onFocus={handleFocus}
                onBlur={handleBlur}
                maxLength={field.maxLength}
              />
            </React.Fragment>
          );
        case 'textsettings':
          return (
            <TextFieldSettings
              type={field.type}
              className={field.className}
              name={field.name}
              nameComp={field.nameComp}
              label={field.label}
              items={field.items}
              disabled={field.disabled}
              placeholder={field.placeholder}
              addorn={field.addorn}
              value={value}
              valueBtn={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        case 'rangedate':
          return (
            <RangeDateField
              type={field.type}
              className={field.className}
              name={field.name}
              disabled={field.disabled}
              label={field.label}
              placeholder={field.placeholder}
              addorn={field.addorn}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );


        case 'search':
          return (
            <React.Fragment>
              <TextField
                type="text"
                className="search"
                name={field.name}
                label={field.label}
                placeholder={field.placeholder}
                addorn={field.addorn}
                maxLength={field.maxLength}
                value={value}
                withError={withError}
                setFieldValue={setFieldValue}
                setTouched={setTouched}
                onFocus={handleFocus}
                onBlur={handleBlur}
              />

            </React.Fragment>
          );
        case 'password':
          return (
            <PasswordField
              name={field.name}
              className={field.className}
              label={field.label}
              placeholder={field.placeholder}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        case 'masked':
          return (
            <MaskField
              type="text"
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              addorn={field.addorn}
              mask={field.mask}
              disabled={field.disabled}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        case 'select':
          return (
            <Dropdown
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              items={field.items}
              optionLabel={field.optionLabel || ''}
              optionValue={field.optionValue || ''}
              anchor={field.anchor}
              addorn={field.addorn}
              emptyMessage={field.emptyMessage}
              displayTemplate={field.displayTemplate}
              hideClearButton={field.hideClearButton}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        case 'upload':
          return (
            <Upload
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );

        case 'uploadperbutton':
          return (
            <UploadPerButton
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        case 'buttongroup':
          return (
            <Buttongroup
              name={field.name}
              items={field.items}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        case 'list':
          return (
            <Dropdown
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              items={field.items}
              optionLabel={field.optionLabel || ''}
              optionValue={field.optionValue || ''}
              anchor={field.anchor}
              addorn={field.addorn}
              emptyMessage={field.emptyMessage}
              displayTemplate={field.displayTemplate}
              hideClearButton={field.hideClearButton}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        case 'textarea':
          return (
            <TextFieldArea
              type={field.type}
              className={field.className}
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              addorn={field.addorn}
              disabled={field.disabled}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        case 'number':
          return (
            <NumberField
              type={field.type}
              className={field.className}
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              addorn={field.addorn}
              disabled={field.disabled}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );

        case 'radionumber':
          return (
            <RadioNumberField
              type={field.type}
              className={field.className}
              name={field.name}
              label={field.label}
              label1={field.label1}
              mask={field.mask}
              placeholder={field.placeholder}
              addorn={field.addorn}
              disabled={field.disabled}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        case 'remainder':
          return (
            <RemainderDaysField
              type={field.type}
              className={field.className}
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              addorn={field.addorn}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />

          );
        case 'checkbox':
          return (
            <Checkboxfield
              name={field.name}
              label={field.label}
              labelcheckbox={field.labelcheckbox}
              placeholder={field.placeholder}
              items={field.items}
              itemsWithInput={field.itemsWithInput}
              itemsWithInputText={field.itemsWithInputText}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        case 'radiobtn':
          return (
            <RadioButton
              type={field.type}
              className={field.className}
              name={field.name}
              label={field.label}
              items={field.items}
              itemsWithInputNumber={field.itemsWithInputNumber}
              itemsWithInputDate={field.itemsWithInputDate}
              itemsWithInputBetweenDate={field.itemsWithInputBetweenDate}
              itemsWithInputBetweenNumber={field.itemsWithInputBetweenNumber}
              placeholder={field.placeholder}
              addorn={field.addorn}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}

            />
          );

        case 'boolean':
          return (
            <Boolean
              type={field.type}
              className={field.className}
              name={field.name}
              disabled={field.disabled}
              label={field.label}
              placeholder={field.placeholder}
              addorn={field.addorn}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}

            />
          );
        case 'date':
          return (
            <DateField
              type={field.type}
              className={field.className}
              name={field.name}
              disabled={field.disabled}
              label={field.label}
              placeholder={field.placeholder}
              addorn={field.addorn}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}

            />
          );
        case 'label':
          return (
            <LabelField
              type={field.type}
              className={field.className}
              name={field.name}
              disabled={field.disabled}
              // label={field.label}
              placeholder={field.placeholder}
              addorn={field.addorn}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}

            />
          );
        case 'matriz':
          return (
            <MatrizField
              type={field.type}
              className={field.className}
              name={field.name}
              nameComp={field.nameComp}
              label={field.label}
              placeholder={field.placeholder}
              addorn={field.addorn}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
              form={field.form}

            />
          );

        case 'selected':
          return (
            <SelectedField
              type={field.type}
              className={field.className}
              name={field.name}
              nameComp={field.nameComp}
              label={field.label}
              placeholder={field.placeholder}
              addorn={field.addorn}
              value={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
              form={field.form}

            />
          );
        case 'listsettings':
          return (
            <DynamicFieldSet
              type={field.type}
              className={field.className}
              name={field.name}
              nameComp={field.nameComp}
              label={field.label}
              items={field.items}
              placeholder={field.placeholder}
              addorn={field.addorn}
              value={value}
              valueBtn={value}
              withError={withError}
              setFieldValue={setFieldValue}
              setTouched={setTouched}
              onFocus={handleFocus}
              onBlur={handleBlur}
              form={field.form}

            />
          );

        case 'link':
          return (
            <Link
              url={field.url}
              text={I18n.l(field.text)}
              className={field.className}
            />
          )
        default:
          return (
            <MissingPropsPlaceholder text={`The type of the field ${field.name} is not valid.`} />
          );
      }
    }

    return <MissingPropsPlaceholder text={`Some of your fields has no name.`} />;
  };

  renderField(props: any, field: FieldType, inline: number = 0): React.ReactNode {
    const { settings } = this.props;
    const { errors, touched } = props;
    const error = errors && field.name && errors[field.name] ? errors[field.name] : '';
    const wasTouched = touched && field.name ? touched[field.name] : '';

    if (field.type === 'fieldset') {
      return (
        <InlineFieldWrapper>
          {field.items &&
            field.items.map((item: any) => (
              <React.Fragment key={JSON.stringify(item)}>
                {this.renderField(props, item, field.items ? field.items.length : 0)}
              </React.Fragment>
            ))}
        </InlineFieldWrapper>
      );
    }

    const errorLabelStyle = field.maxLength != undefined ? { marginTop: '-21px', maxWidth: '90%' } : {};

    return (

      <FieldWrapper className={!!inline ? `inline` : ''} count={inline}>
        {field.label && (
          <Label withError={!!wasTouched && error.length > 0} className={field.className}>
            {settings.labelPreffix}
            {field.label && I18n.l(field.label)}
            {field.labelAddorn && (
              <LabelAddorn>{I18n.l(field.labelAddorn)}</LabelAddorn>
            )}
            {settings.labelSuffix}
          </Label>

        )}

        <span>
          {this.renderComponentByType(field, props, !!wasTouched && error.length > 0)}

          {wasTouched && error && (
            <div style={errorLabelStyle}>
              <ErrorDisplay>
                {I18n.lApi([error])}
              </ErrorDisplay>
            </div>
          )}

        </span>
      </FieldWrapper >

    );
  }

  render() {
    const { settings, debug, onSubmit, onCancel } = this.props;

    if (!settings.fields || settings.fields.length === 0) {
      return null;
    }
    const initialValues = this.getInitialValues(settings);

    return (
      <Formik
        initialValues={initialValues}
        enableReinitialize
        isInitialValid
        validationSchema={settings.validationSchema}
        onSubmit={(values, { setSubmitting, setErrors }) => {
          setSubmitting(true);
          if (onSubmit !== undefined) {
            onSubmit(values, { setSubmitting, setErrors })
          }
        }}
        render={(props: any) => (
          <React.Fragment>
            <Effect
              onChange={(currentFormikState, nextFormikState) => {
                if (
                  !!settings.submitOnFieldChange &&
                  this.submitForm &&
                  !_.isEqual(currentFormikState.values, nextFormikState.values)
                ) {
                  this.submitForm();
                }
              }}
            />

            <FormWrapper onSubmit={props.handleSubmit}>
              {settings.fields &&
                settings.fields.map((item: any) => (
                  <React.Fragment key={JSON.stringify(item)}>
                    {this.renderField(props, item)}
                  </React.Fragment>
                ))}

              {!!this.props.innerComponent && (
                this.props.innerComponent
              )}

              {!settings.submitOnFieldChange &&
                !settings.submitOnKeyEnter && (

                  <ActionsWrapper>
                    {onCancel && (
                      <Button
                        type='primary'
                        size={"large"}
                        className="cancel-button-style"
                        ghost
                        onClick={(e: any) => {
                          e.preventDefault();
                          if (e.detail !== 0) {
                            onCancel();
                          }
                        }}
                      >
                        {settings.cancelButtonText
                          ? I18n.l(settings.cancelButtonText)
                          : I18n.l('common.cancel')}
                      </Button>
                    )}
                    {onSubmit && (
                      <Button
                        size={"large"}
                        className="submit-button-style"
                        loading={!!props.isSubmitting}
                        // disabled={( !props.isSubmitting )}
                        onClick={(e: React.FormEvent<HTMLFormElement>) => {
                          e.preventDefault();
                          props.handleSubmit(e);
                        }}
                      >
                        {settings.submitButtonText
                          ? I18n.l(settings.submitButtonText)
                          : I18n.l('common.save')}
                      </Button>
                    )}
                  </ActionsWrapper>
                )}
            </FormWrapper>
            {!!debug && (
              <React.Fragment>
                <DebugValues>
                  <span>Values: </span>
                  {JSON.stringify(props.values, null, 2)}
                </DebugValues>
                <DebugValues>
                  <span>Touches: </span>
                  {JSON.stringify(props.touched, null, 2)}
                </DebugValues>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      />
    );
  }
}

const FormWrapper = styled.form.attrs({
  className: `form-wrapper`,
})`
  margin: 0;
  width: 100%;

  .hidden {
    display: none;
  }
`;

const InlineFieldWrapper = styled.div.attrs({
  className: `form-inline-wrapper`,
})`
  display: flex;
  justify-content: flex-start
  flex-flow: row nowrap;
  align-items: flex-end;
`;

const FieldWrapper = styled.div.attrs({
  className: `form-field-wrapper`,
})`
  margin: 0;
  padding: 0;
  text-align: left;
  max-width: 100%;

  &.inline {
    flex: 1;
    max-width: ${({ count }: { count: number }) => `${100 / count}%`};
  }
  &.inline:first-of-type {
    margin-right: 0;
  }
  &.inline:last-of-type {
    margin-left: 0;
  }
`;

const LabelAddorn = styled.span`
  color: #999;
`;

const ActionsWrapper = styled.div.attrs({
  className: `form-actions-wrapper`,
})`
  margin-top: 50px;
  text-align: right;

  .link {
    margin: 0 20px;
  }

.submit-button-style {
  color: #FFFFFF;
  background-color: #335D7C;
  border-radius: 30px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
}
.cancel-button-style {
  color: #335D7C;
  background-color:#FFFFFF;
  border-radius: 30px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
}
  
`;

const DebugValues = styled.pre`
  background: '#f2f2f2';
  border: 1px solid #ddd;
  color: '#333';
  font-style: italic;
  margin: 20px 0;
  padding: 10px;
  text-align: left;
`;

export default FormBuilder;
